export enum InquiryType {
    SHOOTING, EDUCATION
}

export const InquiryTypeList = [
    {
        type: InquiryType.SHOOTING,
        name: "촬영 문의"
    },
    {
        type: InquiryType.EDUCATION,
        name: "교육 문의"
    },
];

export enum StatusType {
    NOT_COMPLETE, COMPLETE
}

export const StatusTypeList = [
    {
        type: StatusType.NOT_COMPLETE,
        name: "미처리"
    },
    {
        type: StatusType.COMPLETE,
        name: "처리 완료"
    },
];

export const getInquiryTypeName = (seq: number) => {
    return InquiryTypeList.find((inquiryType) => inquiryType.type === seq)?.name;
}

export enum InquiryKeywordType {
    USER, EMAIL, PHONE, CONTENT
}

export const InquiryKeywordTypeList = [
    {
        type: InquiryKeywordType.USER,
        name: "사용자명"
    },
    {
        type: InquiryKeywordType.EMAIL,
        name: "이메일"
    },
    {
        type: InquiryKeywordType.PHONE,
        name: "연락처"
    },
    {
        type: InquiryKeywordType.CONTENT,
        name: "내용"
    }
];

export const getInquiryKeywordTypeName = (seq: number) => {
    return InquiryKeywordTypeList.find((inquiryKeywordType) => inquiryKeywordType.type === seq)?.name;
}